import { FC } from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';

import PageNotFound from '~src/shared/errorPages/PageNotFound';
import { routes } from '~src/routingConfig';
import { itemIdMatch } from '~src/constants';

import UsersPreviewList from './importUsers/usersPreviewList/UsersPreviewList';
import CompanySettings from './containers/CompanySettings';
import ImportSummary from './importUsers/ImportSummary';

type Props = RouteComponentProps<object>;

const CompanySettingsRouter: FC<Props> = props => (
  <Switch>
    <Route exact strict path={props.match.url} component={CompanySettings} />
    <Route
      exact
      strict
      path={`${routes.company.importUsers}/:importId(${itemIdMatch})`}
      component={UsersPreviewList}
    />
    <Route
      exact
      strict
      path={`${routes.company.importUsers}/:importId(${itemIdMatch})/summary`}
      component={ImportSummary}
    />
    <PageNotFound {...props} />
  </Switch>
);
export default CompanySettingsRouter;
